/** A saved Note, or the log line (it shares Note history), changed. */
export const NOTE_CHANGED_EVENT = 'note-changed';

export function notifyNoteChanged(storyId) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(NOTE_CHANGED_EVENT, {
    detail: { storyId: storyId == null ? null : String(storyId) },
  }));
}

/**
 * Book Notes can be open in this tab, or left open in another, while a
 * note is saved from Write. Refetch when this page is shown again, and
 * when a save in this tab says the notes changed.
 */
export function bindNoteRefresh(storyId, reload) {
  if (typeof window === 'undefined' || typeof reload !== 'function') {
    return () => {};
  }
  const refresh = () => {
    if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
    reload();
  };
  const onVisible = () => {
    if (document.visibilityState === 'visible') refresh();
  };
  const onPageShow = (event) => {
    if (event.persisted) refresh();
  };
  const onNote = (event) => {
    const changedId = event?.detail?.storyId;
    if (changedId && storyId && String(changedId) !== String(storyId)) return;
    refresh();
  };
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('pageshow', onPageShow);
  window.addEventListener('focus', refresh);
  window.addEventListener(NOTE_CHANGED_EVENT, onNote);
  return () => {
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('pageshow', onPageShow);
    window.removeEventListener('focus', refresh);
    window.removeEventListener(NOTE_CHANGED_EVENT, onNote);
  };
}
